import { useState } from "react";
import BaseModal from "./BaseModal";
import Icon1 from "@assets/icons/Icon";
import TextField from "@components/ui/textfields/TextField";
import DropDown from "@components/ui/dropdown/DropDown";
import Button from "@components/ui/buttons/Button";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";
import { dossiersApi } from "@services/api/dossiers";
import { useDossierStore } from "@store/dossierStore";
import { showNotification } from "context/notification.service";
import type { Dossier, DossierType } from "types/dossier";

const DOSSIER_TYPE_OPTIONS = [
  { value: "particulier", label: "Particulier" },
  { value: "professionnel", label: "Professionnel" },
  { value: "loueur", label: "Loueur" },
  { value: "garantie", label: "Garantie" },
  { value: "occasion", label: "Véhicule occasion" },
  { value: "interne", label: "Véhicule interne" },
];

interface DossierEditModalProps {
  dossier: Dossier;
  onClose: () => void;
  onSuccess: (updated: Dossier) => void;
}

export default function DossierEditModal({ dossier, onClose, onSuccess }: DossierEditModalProps) {
  const [name, setName] = useState(dossier.name || "");
  const [type, setType] = useState<DossierType>(dossier.type || "particulier");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!name.trim()) {
      showNotification({ type: "error", message: "Le nom du dossier est requis" });
      return;
    }
    setSaving(true);
    try {
      const updated = await dossiersApi.update(dossier.id, {
        name: name.trim(),
        type,
      });
      useDossierStore.getState().updateDossier(updated);
      onSuccess(updated);
      showNotification({ type: "success", message: "Dossier mis à jour" });
      onClose();
    } catch {
      showNotification({ type: "error", message: "Erreur lors de la mise à jour du dossier" });
    }
    setSaving(false);
  };

  return (
    <BaseModal
      onClose={onClose}
      title="Modifier le dossier"
      startIcon={<Icon1 name="modify" size={20} />}
    >
      <div className="flex flex-col gap-4 p-6">
        <TextField
          label="Nom du dossier"
          value={name}
          onChange={(e: any) => setName(e.target.value)}
          placeholder="Nom du dossier"
        />
        <DropDown
          label="Type de dossier"
          value={type}
          onSelect={(val: string | number) => setType(val as DossierType)}
          options={DOSSIER_TYPE_OPTIONS}
        />
        <div className="flex flex-row justify-end gap-3 pt-4">
          <SecondaryButton label="Annuler" onClick={onClose} />
          <Button label={saving ? "Enregistrement..." : "Enregistrer"} onClick={handleSave} disabled={saving} />
        </div>
      </div>
    </BaseModal>
  );
}
